module.exports = __webpack_public_path__ + "static/theo-companies-taxi@2x-94382f84ce6a3d23fbd8b06d85b6ebf7.png";